<p-dialog
  data-testid="selected-sku-dialog"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '1000px', maxWidth: '95vw' }"
  [header]="getDialogHeader()"
  (onHide)="onCancel()"
>
  <!-- Search Form -->
  <div class="mb-4">
    <app-search-form
      data-testid="selected-sku-dialog-search-form"
      [searchFormat]="searchFormat"
      (formSearch)="onSearch($event)"
      (formReset)="onSearchReset()"
    ></app-search-form>
  </div>

  <!-- SKU Selection Table -->
  <div class="mb-4">
    <app-data-table
      data-testid="selected-sku-dialog-table"
      [dataSource]="skuItems"
      [columns]="tableColumns"
      [loading]="loading()"
      [totalRecords]="totalRecords"
      [rows]="20"
      [selection]="selectedSkus"
      (selectionChange)="selectedSkus = $event"
      [hasCheckColumn]="true"
      [hasHeaderCheckbox]="true"
      [hasSerialColumn]="false"
      [isRowSelectedFn]="getSkuSelectionState.bind(this)"
      (pageChange)="onLazyLoad($event)"
      [scrollHeight]="'450px'"
      class="w-full"
    />
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <!-- Cancel button -->
      <app-button
        [testId]="'selected-sku-dialog-cancel-btn'"
        label="purchase_request.actions.cancel"
        type="secondary"
        [outlined]="true"
        (emitOnClick)="onCancel()"
        [disabled]="loading()"
      ></app-button>

      <!-- Add button -->
      <app-button
        [testId]="'selected-sku-dialog-add-btn'"
        label="purchase_request.actions.add"
        type="info"
        (emitOnClick)="onConfirm()"
        [disabled]="loading()"
      ></app-button>
    </div>
  </ng-template>
</p-dialog>

<!-- Toast Messages -->
<p-toast data-testid="selected-sku-dialog-toast"></p-toast>
